export interface PlpSavedState {
    allProducts: any[];
    startPage: number;
    endPage: number;
    stableTotal: number;
    stableTotalPages: number;
    stableFilters: any[];
    stableCurrentFilters: any;
    stableSorts: any[];
}

export function usePlpPersistence(route: ReturnType<typeof useRoute>) {
    const plpStateKey = `plp-${route.path.replace(/[^a-zA-Z0-9-/]/g, '')}`;
    const savedPlpState = useState<(PlpSavedState & { querySnapshot: string; lastClickedProductId: string | null }) | null>(
        plpStateKey,
        () => null,
    );
    const isRestoringFromCache = ref(false);
    const lastClickedProductId = ref<string | null>(null);

    provide('onProductClick', (productId: string) => {
        lastClickedProductId.value = productId;
    });

    let restoredState: PlpSavedState | null = null;
    if (import.meta.client && savedPlpState.value) {
        const currentQuerySnapshot = JSON.stringify(route.query);
        if (savedPlpState.value.querySnapshot === currentQuerySnapshot) {
            isRestoringFromCache.value = true;
            restoredState = savedPlpState.value;

            const scrollTargetId = savedPlpState.value.lastClickedProductId;
            if (scrollTargetId) {
                onMounted(() => {
                    nextTick(() => {
                        const el = document.querySelector(`[data-product-id="${scrollTargetId}"]`);
                        if (el) {
                            const rect = el.getBoundingClientRect();
                            window.scrollTo({ top: window.scrollY + rect.top - 300, behavior: 'instant' });
                        }
                    });
                });
            }
        }
        savedPlpState.value = null;
    }

    function save(state: PlpSavedState) {
        if (import.meta.client) {
            savedPlpState.value = {
                ...state,
                querySnapshot: JSON.stringify(route.query),
                lastClickedProductId: lastClickedProductId.value,
            };
        }
    }

    return { isRestoringFromCache, lastClickedProductId, restoredState, save };
}
